import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=13c3ddf4&scoped=true"
import script from "./DropZone.vue?vue&type=script&lang=js"
export * from "./DropZone.vue?vue&type=script&lang=js"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=13c3ddf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3ddf4",
  null
  
)

export default component.exports